<template>
  <div class="panel panel-default">
    <div class="panel-heading">{{ caixaAlta(limitar(medico.nome, 30)) }}</div>
    <div class="panel-body panel_info">
      <table class="table table-striped table-hover tabela_info">
        <tbody>
          <tr>
            <td><strong>CBO</strong></td>
            <td v-if="medico.cbo" :title="medico.cbo.valor">{{
              medico.cbo.codigo
            }}</td>
            <td v-if="!medico.cbo">Não informado</td>
          </tr>
          <tr>
            <td><strong>Conselho</strong></td>
            <td>{{ medico.conselho }} / {{ medico.ufConselho }}</td>
          </tr>
          <tr>
            <td><strong>No. conselho</strong></td>
            <td>{{ medico.numeroConselho }}</td>
          </tr>
          <tr>
            <td><strong>Situação</strong></td>
            <td :class="medico.ativo ? 'text-success' : 'text-danger'">{{
              medico.ativo ? 'Ativo' : 'Cancelado'
            }}</td>
          </tr>
        </tbody>
      </table>
      <div class="btn-group btn-group-justified" role="group">
        <RouterLink
          data-test-id="link-auto-1"
          :to="'/medico/cadastro/' + medico._id"
          role="button"
          class="btn btn-sm btn-default"
          ><span class="fa fa-edit" /> Editar</RouterLink
        >
      </div>
    </div>
  </div>
</template>

<script>
import * as formatadores from '@/utils/formatadores'

export default {
  name: 'MedicoFicha',
  props: {
    medico: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...formatadores,
  },
}
</script>
